import * as React from 'react';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import TextCollection from 'components/AssetsCollection';
import { EntityType } from 'const';
import { TextCollectionMap } from 'models';
import { intlGet } from 'utils/intlGet';
import { TextCollectionListProps } from './models';
import styles from './styles.module.scss';

const TextCollectionList: React.FunctionComponent<TextCollectionListProps> = (props) => {
  const {
    items,
    showUpdatedTextCollections,
    toggleUpdatedDocumentsDisplaying,
    updatedInPromoMats,
    dataTestId = 'textCollectionList',
  } = props;

  const {
    expanded,
    toggle,
  } = useToggle({
    toggleUpdatedDocumentsDisplaying,
    showUpdatedDocuments: showUpdatedTextCollections,
    entityType: EntityType.TEXT_COLLECTION,
  });
  const hasItems = items && items.size > 0;

  if (!hasItems) {
    return null;
  }

  return (
    <div className={styles.TextCollectionList} data-title="text-collections" data-testid={dataTestId}>
      <Header
        title={intlGet('Assets', 'TextCollections', { count: items.size })}
        showUpdatesHint={updatedInPromoMats && showUpdatedTextCollections}
        expanded={expanded}
        onClick={toggle}
        dataTestId={`${dataTestId}-header`}
      />
      {
        expanded &&
        <List
          elements={items}
          renderElement={(item: TextCollectionMap, index): React.ReactNode => (
            <TextCollection key={index} document={item} dataTestId={`${dataTestId}-list-item${index}`} />
          )}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default TextCollectionList;
